import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';
import { Grid } from 'react-virtualized';
import Popover from '../../../components/Popover';
import Emoji from './Emoji';
import EmojiPickerPreview from './PickerPreview';
import computePopoverControl from '../../utils/computePopoverControl';
var POPOVER_HEIGHT = 272;
var POPOVER_WIDTH = 268;
var POPOVER_BOTTOM_HEIGHT = 60;
var EMOJI_WIDTH = 36;

var Picker =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Picker, _React$PureComponent);

  function Picker(props, context) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onPluginStateChange", function () {
      var pluginState = _this.props.pluginStore.getItem('state');

      _this.setState(_objectSpread({}, pluginState));
    });

    _defineProperty(_assertThisInitialized(_this), "computeControl", function () {
      var _this$props = _this.props,
          editor = _this$props.editor,
          bottomSpace = _this$props.bottomSpace;
      var popoverControl = computePopoverControl({
        // eslint-disable-next-line react/no-find-dom-node
        containerEl: editor.el,
        bottomSpace: bottomSpace,
        popoverMaxHeight: POPOVER_HEIGHT,
        popoverMaxWidth: POPOVER_WIDTH
      });

      if (!popoverControl) {
        return;
      }

      _this.setState({
        popoverStyle: popoverControl.style
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCell", function (_ref) {
      var columnIndex = _ref.columnIndex,
          key = _ref.key,
          rowIndex = _ref.rowIndex,
          style = _ref.style;
      var index = columnIndex + rowIndex * _this.state.itemsPerRow;
      var item = _this.state.items[index];

      if (!item) {
        return false;
      }

      return React.createElement(Emoji, {
        key: key,
        index: index,
        emoji: _this.state.items[index],
        isSelected: index === _this.state.index,
        onSelect: _this.onSelectEmoji,
        onClick: _this.onClickEmoji,
        style: style
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickEmoji", function (event, emoji, index) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onClick(emoji, index);

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectEmoji", function (event, emoji, index) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onSelect(emoji, index);

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      return event.preventDefault();
    });

    _this.state = _objectSpread({
      popoverStyle: {}
    }, _this.props.pluginStore.getItem('state'));
    return _this;
  }

  _createClass(Picker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isVisible) {
        this.computeControl();
      }

      this.props.pluginStore.subscribeToItem('state', this.onPluginStateChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Recompute popover position when it appears
      if (prevState.isVisible !== this.state.isVisible) {
        this.computeControl();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.pluginStore.unsubscribeFromItem('state', this.onPluginStateChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          popoverStyle = _this$state.popoverStyle,
          isVisible = _this$state.isVisible,
          index = _this$state.index,
          items = _this$state.items,
          itemsPerRow = _this$state.itemsPerRow,
          notFoundEmoji = _this$state.notFoundEmoji,
          placeholderEmoji = _this$state.placeholderEmoji;
      var selectedEmoji = items[index];

      if (!isVisible) {
        return false;
      }

      return React.createElement(Popover, {
        style: _objectSpread({}, popoverStyle, {
          width: POPOVER_WIDTH,
          height: POPOVER_HEIGHT
        })
      }, React.createElement("div", {
        className: "flexbox flexbox-column height-full no-selection",
        onMouseDown: this.onMouseDown
      }, React.createElement("div", null, React.createElement(Grid, {
        key: this.state.searchWord,
        className: 'padding-vertical-small padding-horizontal-small',
        cellRenderer: this.renderCell,
        columnCount: Math.min(items.length, itemsPerRow),
        columnWidth: EMOJI_WIDTH,
        rowCount: Math.ceil(items.length / itemsPerRow),
        rowHeight: EMOJI_WIDTH,
        height: POPOVER_HEIGHT - POPOVER_BOTTOM_HEIGHT,
        width: POPOVER_WIDTH,
        overscanRowCount: 5,
        scrollToRow: Math.floor(index / itemsPerRow + 0.5),
        scrollToColumn: index % itemsPerRow,
        tabIndex: null
      })), React.createElement(EmojiPickerPreview, {
        index: index,
        selectedEmoji: selectedEmoji,
        placeholderEmoji: placeholderEmoji,
        notFoundEmoji: notFoundEmoji,
        onSelectEmoji: this.onSelectEmoji,
        onClickEmoji: this.onClickEmoji
      })));
    }
  }]);

  return Picker;
}(React.PureComponent);

_defineProperty(Picker, "propTypes", {
  pluginStore: PropTypes.shape({
    getItem: PropTypes.func.isRequired,
    subscribeToItem: PropTypes.func.isRequired,
    unsubscribeFromItem: PropTypes.func.isRequired
  }),
  editor: PropTypes.instanceOf(Editor).isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  bottomSpace: PropTypes.number.isRequired
});

export default Picker;